import { Component } from '@angular/core';

import { BusinessDocumentListView } from '../../services/business-document-list-view';
import { RecordListViewMode } from '../../record-list/record-list.types';

@Component({
  selector: 'app-business-document-view-toggle',
  standalone: false,
  templateUrl: './business-document-view-toggle.html',
  styleUrl: './business-document-view-toggle.scss',
})
export class BusinessDocumentViewToggle {
  readonly state$;

  constructor(private readonly listView: BusinessDocumentListView) {
    this.state$ = listView.state$;
  }

  setMode(mode: RecordListViewMode): void {
    this.listView.setMode(mode);
  }

  label(mode: RecordListViewMode): string {
    return mode === 'card' ? 'Card' : mode[0].toUpperCase() + mode.slice(1);
  }
}
